export const downloadFile = async (url, filename, headers) => {
  const res = await fetch(url, { headers, credentials: 'include' });
  if (!res.ok) throw new Error('Download failed');
  const blob = await res.blob();
  const u = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = u;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(u);
};

export const sortRows = (rows, sort, dateKey) => {
  const name = r => (r.employee_name || '').toLowerCase();
  const dept = r => (r.department || '').toLowerCase();
  switch (sort) {
    case 'employee_list': {
      const ord = r => (r.display_order == null ? 1e9 : Number(r.display_order));
      return [...rows].sort((a, b) => ord(a) - ord(b) || dept(a).localeCompare(dept(b)) || name(a).localeCompare(name(b)));
    }
    case 'name_asc': return [...rows].sort((a, b) => name(a).localeCompare(name(b)));
    case 'name_desc': return [...rows].sort((a, b) => name(b).localeCompare(name(a)));
    case 'department': return [...rows].sort((a, b) => dept(a).localeCompare(dept(b)) || name(a).localeCompare(name(b)));
    case 'date_desc': return dateKey ? [...rows].sort((a, b) => (b[dateKey] || '').localeCompare(a[dateKey] || '')) : rows;
    case 'date_asc': return dateKey ? [...rows].sort((a, b) => (a[dateKey] || '').localeCompare(b[dateKey] || '')) : rows;
    default: return rows;
  }
};

export const printReport = (title, subtitle, headers, rows) => {
  const w = window.open('', '_blank', 'width=1000,height=700');
  if (!w) return;
  const th = headers.map(h => `<th>${h}</th>`).join('');
  const trs = rows.map(r => `<tr>${r.map(c => `<td>${c == null ? '—' : c}</td>`).join('')}</tr>`).join('');
  w.document.write(`<!DOCTYPE html><html><head><title>${title}</title><style>
    body{font-family:Arial,sans-serif;margin:24px;color:#111}
    h1{font-size:18px;margin:0 0 2px} p.sub{font-size:12px;color:#555;margin:0 0 14px}
    table{width:100%;border-collapse:collapse;font-size:11px}
    th,td{border:1px solid #999;padding:5px 7px;text-align:left;vertical-align:top}
    th{background:#f3f4f6;font-weight:bold}
    tr:nth-child(even) td{background:#fafafa}
    @media print{ @page{size:landscape;margin:12mm} }
  </style></head><body>
    <h1>${title}</h1><p class="sub">${subtitle} · Printed ${new Date().toLocaleString('en-IN')}</p>
    <table><thead><tr>${th}</tr></thead><tbody>${trs}</tbody></table>
  </body></html>`);
  w.document.close();
  w.focus();
  setTimeout(() => w.print(), 400);
};
